import * as React from 'react';
import { Dispatch } from 'redux';
import { connect } from 'react-redux';

import { Magazine } from '../../components/magazine/magazine';

import { IMagazineItem } from '../../models/magazine';
import { IDigestState } from '../../models/digest';
import { IConfig } from '../../models/config';
import { IStore } from '../../models/store';

interface IProps {
  journal: IMagazineItem[];
  digest: IDigestState;
  config: IConfig;
  dispatch: Dispatch<any>;
}

class MagazineBlock extends React.Component<IProps, {}> {
  public render() {
    return (
      <Magazine
          contentUrl={this.props.config.frontContentUrl}
          news={this.getNews()}
          articles={this.getArticles()}
          blogs={this.getBlogs()}
          questions={this.getQuestions()}
          digestState={this.props.digest}
      />
    );
  }

  private getNews() {
    return this.props.journal.filter((item) => (item.attributes.type === 'news')).slice(0, 6);
  }

  private getArticles() {
    return this.props.journal.filter((item) => (item.attributes.type === 'articles')).slice(0, 4);
  }

  private getBlogs() {
    return this.props.journal.filter((item) => (item.attributes.type === 'blogs')).slice(0, 3);
  }

  private getQuestions() {
    return this.props.journal.filter((item) => (item.attributes.type === 'questions')).slice(0, 4);
  }
}

const mapStateToProps = (state: IStore) => ({
  journal: state.mainpage.contentPartData,
  digest: state.digest,
  config: state.config,
});

export const MagazineContainer = connect<{}, {}, any>(mapStateToProps)(MagazineBlock);
